module.exports = __webpack_public_path__ + "static/ch-1c9aea375b79757a67bc6552ab38e14a.jpg";